import { action, loading, observable, store } from '~/common/mobx.decorator'
import { notifyStore } from '~/stores'
import { apolloClient } from '~/common/apollo'
import { CREATE_CONTACT_INQUIRIES_MUTATION } from '~/common/apollo/mutations/contact.mutation'

@store()
class ContactStore {
	@observable contactForms = []
	@observable pageInfo = {}

	@observable showSendInquiriesDialog = false
	@observable showSendInquiriesResultDialog = false

	@observable contactSupportTeam = {} // Contain email only
	@observable contactAdvisor = {}
	@observable contactCaseManager = {}

	/**
	 * ContactFormTypeEnum
	 * technical - Send to technical support
	 * employer - Send to candidate's Advisor
	 * second_employed - Send to candidates Case Manager
	 */
	@observable selectedTab

	@action
	setSelectedTab = (tab) => {
		if (!tab) return
		this.selectedTab = tab
	}

	/**
	 * The payload data to submit the inquiry request
	 * e.g., email, phone number, whatsapp etc.
	 */
	@observable payload = {
		contactType: null,
		content: null,
		subject: null,
	}

	@action
	updateContactForms = (contactForms) => {
		this.contactForms = contactForms
	}

	@action
	updatePageInfo = (pageInfo) => {
		this.pageInfo = pageInfo
	}

	@action
	setShowSendInquiriesDialog = (show) => {
		this.showSendInquiriesDialog = show
	}

	@action
	setShowSendInquiriesResultDialog = (show) => {
		this.showSendInquiriesResultDialog = show

		this.clearPayload()
	}

	@action
	setPayload = (payload) => {
		this.payload = payload
	}

	@action
	updatePayload = (key, value) => {
		this.payload[key] = value
	}

	@action
	clearPayload = () => {
		this.payload = {}
	}
	@loading
	@action
	submitContactForm = async () => {
		try {
			const variables = {
				contactType: this.selectedTab,
				content: this.payload.content,
			}
			const res = await apolloClient.mutate({
				mutation: CREATE_CONTACT_INQUIRIES_MUTATION,
				variables,
			})

			const { data } = res || {}
			if (!data) throw new Error('No data')

			if (data?.createContactForm?.status === 'sent') {
				this.setShowSendInquiriesDialog(false)
				// Show success dialog
				this.setShowSendInquiriesResultDialog(true)
			} else {
				throw new Error('Can not send the inquiry')
			}
		} catch (e) {
			console.error(e)
			notifyStore.error(e?.message || 'Failed to submit contact form')
		}
	}
}

export const contactStore = new ContactStore()
